import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="export-search"
// On click, reads the search form's current values and navigates to the export URL with those params.
export default class extends Controller {
  static values = { url: String, formId: String }

  export(event) {
    event.preventDefault()

    const form = document.getElementById(this.formIdValue)
    if (!form) {
      window.location.href = this.urlValue
      return
    }

    const formData = new FormData(form)
    const params = new URLSearchParams()

    for (const [key, value] of formData.entries()) {
      if (value && key !== "utf8" && key !== "authenticity_token" && key !== "commit" && key !== "search_tab") {
        params.append(key, value)
      }
    }

    const queryString = params.toString()
    const separator = this.urlValue.includes("?") ? "&" : "?"

    window.location.href = queryString
      ? `${this.urlValue}${separator}${queryString}`
      : this.urlValue
  }
}
